/**
 * Asteroid types configuration
 *
 * This file is auto-generated by the balance importer.
 * Do not edit manually - changes will be overwritten.
 *
 * Generated at: 2025-09-25T12:43:18.991Z
 */

import { ConfigType } from './ConfigType';

export interface AsteroidConfig {
  asteroid_id: string;
  name: string;
  tier: number;
  value_id: string;
  base_hp_unit: number;
  base_armor: number;
  resist_laser_bomb: Record<string, any>;
  notes: any;
  configType: ConfigType.ASTEROIDS;
}

export const asteroidsData: Record<string, AsteroidConfig> = {
  AST_BSLT: {
    asteroid_id: 'AST_BSLT',
    name: 'Basalt Neonized',
    tier: 1,
    value_id: 'VAL_BASIC',
    base_hp_unit: 7,
    base_armor: 0,
    resist_laser_bomb: ['{0.00', '0.00}'],
    notes: 'базовый «камень»',
    configType: ConfigType.ASTEROIDS,
  },
  AST_QTZ: {
    asteroid_id: 'AST_QTZ',
    name: 'Fluxed Quartz',
    tier: 1,
    value_id: 'VAL_RICH',
    base_hp_unit: 7,
    base_armor: 2,
    resist_laser_bomb: ['{0.05', '0.00}'],
    notes: ['чуть толще', 'легкая лазер-резист'],
    configType: ConfigType.ASTEROIDS,
  },
  AST_FRR: {
    asteroid_id: 'AST_FRR',
    name: 'Ferrospark Ore',
    tier: 2,
    value_id: 'VAL_RICH',
    base_hp_unit: 7,
    base_armor: 4,
    resist_laser_bomb: ['{0.10', '0.00}'],
    notes: 'руда для NeonSteel',
    configType: ConfigType.ASTEROIDS,
  },
  AST_LUM: {
    asteroid_id: 'AST_LUM',
    name: 'Lumenite Crystal',
    tier: 2,
    value_id: 'VAL_RARE',
    base_hp_unit: 7,
    base_armor: 6,
    resist_laser_bomb: ['{0.10', '0.05}'],
    notes: 'редкий люменит',
    configType: ConfigType.ASTEROIDS,
  },
  AST_VEIN: {
    asteroid_id: 'AST_VEIN',
    name: 'Neon Vein Node',
    tier: 3,
    value_id: 'VAL_VEIN',
    base_hp_unit: 7,
    base_armor: 8,
    resist_laser_bomb: ['{0.12', '0.08}'],
    notes: '«узел» с фрагментацией по умолчанию',
    configType: ConfigType.ASTEROIDS,
  },
};

/**
 * Get AsteroidConfig by asteroid_id
 */
export function getAsteroids(id: string): AsteroidConfig | undefined {
  return asteroidsData[id];
}

/**
 * Get all AsteroidConfig entries
 */
export function getAllAsteroids(): AsteroidConfig[] {
  return Object.values(asteroidsData);
}

/**
 * Check if AsteroidConfig exists
 */
export function hasAsteroids(id: string): boolean {
  return id in asteroidsData;
}
